<template>
  <div>
    <h2>{{ title }}</h2>
    <loading :active.sync="isLoading" :is-full-page="true"></loading>
    <template>
      <v-system-bar class="branch-data">
        <v-spacer></v-spacer>
        <div v-on:keypress.enter.prevent="getFaqTable(1)">
          <input-search
            :model="search" @update="searchInput"/>
        </div>
        <circle-button
          v-if="permissionFaq && permissionFaq.permission_id === permission.readWrite"
          @click.native="createFaqData"/>
      </v-system-bar>
    </template>
    <template>
      <v-simple-table class="branch-data">
        <template v-slot:default>
          <thead>
          <tr>
            <th class="text-center" v-for="header in headers" :key="header.id">
              {{ header.text }}
            </th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(data,index) in dataTable" :key="data.id">
            <td>{{((dataPaginate.current_page-1)*10)+(index+1)}}</td>
            <td>{{data.category_name}}</td>
            <td>{{data.question_en}}</td>
            <td>{{data.updated_at | moment('DD-MM-YYYY')}}</td>
            <td>
              <a @click="showFaqData(data.id)">
                <icon-pencil/>
              </a>
            </td>
          </tr>
          </tbody>
        </template>
      </v-simple-table>
    </template>
    <paginate :length="dataPaginate.last_page"
              :page="dataPaginate.current_page"
              @update="changePage">
    </paginate>
  </div>
</template>

<script>
  import IconPencil from "../../components/Icon/icon-pencil";
  import CircleButton from "../../components/Button/CircleButton";
  import InputSearch from "../../components/Input/InputSearch";
  import Paginate from "../../components/Layout/Paginate";
  import {permissionFaq, role} from "../../util/Permission";
  import {mapState} from "vuex";
  import Loading from 'vue-loading-overlay';
  import Swal from "sweetalert";
  export default {
    name: "FaqTable",
    components: {Paginate, InputSearch, CircleButton, IconPencil, Loading},
    data() {
      return {
        title: "Faq",
        isLoading: false,
        headers: [
          { id: 1, text: "No." },
          { id: 2, text: "Category" },
          { id: 3, text: "Question" },
          { id: 4, text: "Update date" },
          { id: 5, text: "Edit" },
        ],
        dataTable: [],
        dataPaginate: {
          current_page: 1,
          from: 1,
          last_page: 1,
          per_page: 1,
          total: 1,
          to: 1
        },
        permission : null,
        search : '',
      };
    },
    created() {
      this.permission = role;
      this.getFaqTable(1);
    },
    computed: {
      permissionFaq,
    },
    methods:{
      getFaqTable(page){
        this.isLoading = true;
        this.$store.dispatch("Faq/getFaq",{
          page,
          search : this.search
        }).then(res=>{
          if(res.response_code == 200){
            this.dataTable = res.result.data;
            this.dataPaginate = {
              current_page: res.result.current_page,
              from: res.result.from,
              last_page: res.result.last_page,
              per_page: res.result.per_page,
              total: res.result.total,
              to: res.result.to
            }
          }
          this.isLoading = false;
        }).catch(()=>{
          Swal('','Cannot get Faq data','error');
          this.isLoading = false;
        })
      },
      async changePage(val){
        this.isLoading = true;
        this.dataPaginate.current_page = val;
        await this.getFaqTable(this.dataPaginate.current_page);
        this.isLoading = false;
      },
      goToFaqEdit(){
        this.$router.push("/faqs/edit");
      },
      showFaqData(id){
        this.isLoading = true;
        this.$store.dispatch("Faq/showFaq",id).then(res=>{
          if(res.response_code == 200){
            this.$store.dispatch("Faq/setFormFaq",res.result).then(()=>{
              this.goToFaqEdit();
            })
          }
          this.isLoading = false;
        }).catch(()=>{
          Swal('','Cannot get Faq data','error');
          this.isLoading = false;
        });
      },
      createFaqData(){
        this.$store.dispatch("Faq/clearFormData").then(()=>{
          this.goToFaqEdit();
        });
      },
      searchInput(val){
        this.search = val;
      },
    }
  }
</script>

<style scoped>
  .branch-data {
    background-color: transparent;
    margin: 20px;
  }
</style>
